import { UserEventsService, StorageService } from '../services'

export const userEvents = async (
	handle,
	handleType,
	EVENT,
	campaignCode,
	rootURL,
	campaignSource,
	tripInfo
) => {
	let {
		userAgent,
		platform,
		language,
		vendor,
		connection,
		geolocation,
		cookieEnabled
	} = window.navigator

	let geolocationData = null

	try {
		const permission = await navigator.permissions.query({
			name: 'geolocation'
		})

		if (permission.state === 'granted' && geolocation && geolocation.getCurrentPosition) {
			const { coords } = await new Promise((resolve, reject) => {
				geolocation.getCurrentPosition(resolve, reject)
			})

			geolocationData = coords
		}

	} catch (e) {
		console.error('Erro ao obter geolocalização:', e)
	}

	try {
		const sessionId = StorageService.useSessionId.get()

		if (!sessionId) {
			console.warn('SessionId não disponível ao salvar evento de usuário')
		}

		UserEventsService.save({
			sessionId: sessionId || '',
			eventDescription: EVENT,
			url: document.URL,
			campaignId: campaignCode || '',
			rootURL: rootURL || '',
			campaignSource: campaignSource || '',
			eventData: JSON.stringify(tripInfo || {}),
			infoData: JSON.stringify({
				geolocationData,
				userAgent,
				platform,
				language,
				vendor,
				connection,
				cookieEnabled
			}),
			handle,
			handleType
		})
	} catch (error) {
		console.error('Erro ao salvar evento de usuário:', error)
	}
}
